import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  confirmText: string;
  itemName: string;
}

export default function DeleteConfirmationDialog({
  open,
  onClose,
  onConfirm,
  title,
  confirmText,
  itemName,
}: Props) {
  const { t } = useTranslation();
  const [confirmationText, setConfirmationText] = useState('');

  const handleConfirm = () => {
    if (confirmationText === itemName) {
      onConfirm();
      setConfirmationText('');
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          {t('common.delete-confirmation', { name: itemName })}
        </Typography>
        <TextField
          autoFocus
          fullWidth
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
          label={t('common.type-name-to-confirm')}
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          {t('common.cancel')}
        </Button>
        <Button
          onClick={handleConfirm}
          color="error"
          disabled={confirmationText !== itemName}
          variant="contained"
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
